import { FC } from 'react'

import { useActions, useStore } from 'components/contexts/event-page-filters'
import { generateQtyOptions } from 'components/contexts/event-page-filters/utils'
import { Dropdown } from '~shared'
import { Placeholder } from '~ui'

const EventMenuQuantity: FC = () => {
  const { quantity, loading, globalQuantityOptions, vip } = useStore()
  const { setQuantity } = useActions()

  if (loading) {
    return <Placeholder style={{ width: 180, minHeight: '45px', borderRadius: 8 }} />
  }

  return globalQuantityOptions.length ? (
    <Dropdown
      value={quantity}
      options={generateQtyOptions(globalQuantityOptions, { type: vip ? 'package' : 'ticket' })}
      onSelect={setQuantity}
    />
  ) : null
}

export default EventMenuQuantity
